import * as imagesLoaded from "imagesloaded";
import $ from "jquery";
import jQueryBridget from "jquery-bridget";

function init() {
  jQueryBridget("imagesLoaded", imagesLoaded, $);

  const $container = $(".js-filter-container");

  $container.imagesLoaded(() => {
    const categoryItems = {};

    const arrayForUrl = [];
    let queryForUrl = "";
    let themeForUrl = "";
    let areaForUrl = "";
    let pierForUrl = "";

    let query;
    let themes = "";
    let areas = "";
    let piers = "";

    $(".js-filter-list .filter__checkbox").on("change", function() {
      // Grab selected filters and their parent categories
      const selected = $(this)
        .closest(".js-filter-list")
        .find(".filter__checkbox:checked").length;
      const category = $(this)
        .closest(".js-filter-list")
        .data("category");
      const filters = [];

      // Only allow one selection per category
      $(this)
        .closest(".js-filter-list")
        .find(".filter__checkbox")
        .not(this)
        .prop("checked", false);

      // Build filter object
      $(this)
        .closest(".js-filter-list")
        .find(".filter__checkbox:checked")
        .each(function() {
          filters.push($(this).data("filter"));
          categoryItems[category] = filters;
        });

      // Populate variables from URL if present
      if (urlPage.indexOf("?") > -1) {
        if (getUrlParameter("theme") !== false) {
          themes = '[data-theme~="' + getUrlParameter("theme") + '"],';
          themeForUrl = "theme=" + getUrlParameter("theme");
        }
        if (getUrlParameter("area") !== false) {
          areas = '[data-area~="' + getUrlParameter("area") + '"],';
          areaForUrl = "area=" + getUrlParameter("area");
        }
        if (getUrlParameter("pier") !== false) {
          piers = '[data-pier~="' + getUrlParameter("pier") + '"],';
          pierForUrl = "pier=" + getUrlParameter("pier");
        }
      }

      // Remove category if no options selected
      if (selected === 0) {
        delete categoryItems[category];

        if (category === "theme") {
          themeForUrl = "";
          themes = "";
        } else if (category === "area") {
          areaForUrl = "";
          areas = "";
        } else if (category === "pier") {
          pierForUrl = "";
          piers = "";
        }
      }

      // Get the categories
      const categories = Object.keys(categoryItems);

      // Show all by default if no filters selected
      if (categories === undefined || categories.length === 0) {
        $container.find(".js-filter-item").show();
      } else {
        $container.find(".js-filter-item").hide();
      }

      // Assemble data attribute query
      categories.forEach(type => {
        categoryItems[type].forEach(item => {
          if (type === "theme") {
            themes = '[data-theme~="' + item + '"],';
            themeForUrl = "theme=" + item;
          }
          if (type === "area") {
            areas = '[data-area~="' + item + '"],';
            areaForUrl = "area=" + item;
          }
          if (type === "pier") {
            piers = '[data-pier~="' + item + '"],';
            pierForUrl = "pier=" + item;
          }
        });
      });

      query = "";
      query =
        themes.replace(/,\s*$/, "") +
        areas.replace(/,\s*$/, "") +
        piers.replace(/,\s*$/, "");

      arrayForUrl.length = 0;

      if (themeForUrl !== "") {
        arrayForUrl.push(themeForUrl);
      }
      if (areaForUrl !== "") {
        arrayForUrl.push(areaForUrl);
      }
      if (pierForUrl !== "") {
        arrayForUrl.push(pierForUrl);
      }

      queryForUrl = arrayForUrl.join("&");

      appendUrl(queryForUrl);
      filterItems(query);
    });
  });

  const getUrlParameter = function getUrlParameter(sParam) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split("&");
    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  const filterItems = function(query) {
    // Show filtered items
    $container.find(".js-filter-item" + query).show();

    // Display no results notice if no results are found
    if ($container.children(":visible").length === 0) {
      $container.next().show();
    } else {
      $container.next().hide();
    }
  };

  const appendUrl = function(queryForUrl) {
    if (history.pushState) {
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        queryForUrl;
      window.history.pushState({ path: newurl }, "", newurl);
    }
  };

  const urlPage = window.location.href;
  let urlQuery = "";
  let urlTheme = "";
  let urlArea = "";
  let urlPier = "";

  if (urlPage.indexOf("?") > -1) {
    if (getUrlParameter("theme") !== false) {
      urlTheme = '[data-theme~="' + getUrlParameter("theme") + '"],';
      $('input[data-filter="' + getUrlParameter("theme") + '"]').prop(
        "checked",
        true
      );
      urlQuery += urlTheme.replace(/,\s*$/, "");
    }
    if (getUrlParameter("area") !== false) {
      urlArea = '[data-area~="' + getUrlParameter("area") + '"],';
      $('input[data-filter="' + getUrlParameter("area") + '"]').prop(
        "checked",
        true
      );
      urlQuery += urlArea.replace(/,\s*$/, "");
    }
    if (getUrlParameter("pier") !== false) {
      urlPier = '[data-pier~="' + getUrlParameter("pier") + '"],';
      $('input[data-filter="' + getUrlParameter("pier") + '"]').prop(
        "checked",
        true
      );
      urlQuery += urlPier.replace(/,\s*$/, "");
    }

    $container.find(".js-filter-item").hide();
    filterItems(urlQuery);
  }
}

export default { init };
